import React, { useState } from 'react';
import { database } from "../firebase"; // Adjust the path if necessary

const AddNews = () => {
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [content, setContent] = useState('');
  const [metaTags, setMetaTags] = useState('');
  const [metaImage, setMetaImage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await database.collection('news').add({
        title,
        subTitle,
        content,
        metaTags: metaTags.split(',').map(tag => tag.trim()),
        metaImage,
        createdAt: new Date()
      });
      setTitle('');
      setSubTitle('');
      setContent('');
      setMetaTags('');
      setMetaImage('');
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h1>Add News Article</h1>
      <input
        type="text"
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Sub-title"
        value={subTitle}
        onChange={(e) => setSubTitle(e.target.value)}
        required
      />
      <textarea
        placeholder="Content"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Meta Tags (comma separated)"
        value={metaTags}
        onChange={(e) => setMetaTags(e.target.value)}
      />
      <input
        type="text"
        placeholder="Meta Image URL"
        value={metaImage}
        onChange={(e) => setMetaImage(e.target.value)}
      />
      <button type="submit">Add Article</button>
    </form>
  );
};

export default AddNews;
